import { styled } from "@mui/material/styles";
import React from "react";
import { Streamdown } from "streamdown";
const MONO = "ui-monospace, SFMono-Regular, Menlo, Consolas, monospace";
const Body = styled("div")({
    minWidth: 0,
    fontSize: "var(--j-fs-md)",
    lineHeight: "var(--j-lh-lg)",
    color: "var(--j-ink)",
    overflowWrap: "anywhere",
    "& p": {
        margin: "0 0 var(--j-sp-2)"
    },
    "& > :first-child, & > div > :first-child": {
        marginTop: 0
    },
    "& > :last-child, & > div:last-child > :last-child, & p:last-child": {
        marginBottom: 0
    },
    "& h1, & h2, & h3, & h4, & h5, & h6": {
        margin: "var(--j-sp-3) 0 var(--j-sp-1)",
        fontSize: "var(--j-fs-md)",
        lineHeight: "var(--j-lh-md)",
        fontWeight: 600,
        letterSpacing: "-0.006em"
    },
    "& h1": {
        fontSize: "var(--j-fs-xl)",
        lineHeight: "var(--j-lh-xl)"
    },
    "& h2, & h3": {
        fontSize: "var(--j-fs-lg)",
        lineHeight: "var(--j-lh-lg)"
    },
    "& strong": {
        fontWeight: 600
    },
    "& ul, & ol": {
        margin: "0 0 var(--j-sp-2)",
        paddingLeft: "1.125rem"
    },
    "& li": {
        margin: "var(--j-sp-0-5) 0"
    },
    "& li > p": {
        margin: 0
    },
    "& li::marker": {
        color: "var(--j-ink-3)"
    },
    "& a": {
        color: "var(--j-info-ink)",
        textDecoration: "underline",
        textDecorationColor: "rgb(var(--j-info-ink-rgb) / 0.35)",
        textUnderlineOffset: 2,
        borderRadius: "var(--j-r-xs)",
        "&:hover": {
            textDecorationColor: "var(--j-info-ink)"
        }
    },
    "& blockquote": {
        margin: "0 0 var(--j-sp-2)",
        paddingLeft: "var(--j-sp-3)",
        borderLeft: "2px solid var(--j-line-strong)",
        color: "var(--j-ink-2)"
    },
    "& hr": {
        border: 0,
        height: 1,
        background: "var(--j-line)",
        margin: "var(--j-sp-3) 0"
    },
    "& code": {
        fontFamily: MONO,
        fontSize: "var(--j-fs-sm)"
    },
    "& :not(pre) > code": {
        padding: "1px 4px",
        borderRadius: "var(--j-r-xs)",
        background: "var(--j-well)"
    },
    "& pre": {
        margin: 0,
        padding: "var(--j-sp-2)",
        overflowX: "auto",
        lineHeight: "var(--j-lh-sm)"
    },
    "& [data-streamdown=code-block]": {
        margin: "0 0 var(--j-sp-2)",
        borderRadius: "var(--j-r-md)",
        border: "1px solid var(--j-line)",
        overflow: "hidden",
        background: "var(--j-panel)"
    },
    "& [data-streamdown=code-block-header]": {
        minHeight: "var(--j-btn-h)",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "0 2px 0 var(--j-sp-2)",
        borderBottom: "1px solid var(--j-line)",
        fontSize: "var(--j-fs-xs)",
        lineHeight: "var(--j-lh-xs)",
        color: "var(--j-ink-3)"
    },
    "& [data-streamdown=table-wrapper]": {
        margin: "0 0 var(--j-sp-2)",
        display: "flex",
        flexDirection: "column",
        gap: "var(--j-sp-1)"
    },
    "& [data-streamdown=table-wrapper] > div:last-child": {
        overflowX: "auto",
        borderRadius: "var(--j-r-md)",
        border: "1px solid var(--j-line)",
        background: "var(--j-surface)"
    },
    "& table": {
        width: "100%",
        borderCollapse: "collapse",
        fontSize: "var(--j-fs-md)",
        lineHeight: "var(--j-lh-md)"
    },
    "& th, & td": {
        padding: "var(--j-sp-1) var(--j-cell-x)",
        textAlign: "left",
        verticalAlign: "middle",
        minWidth: 80,
        overflowWrap: "break-word"
    },
    "& th": {
        height: "var(--j-th)",
        fontSize: "var(--j-fs-sm)",
        fontWeight: 500,
        color: "var(--j-ink-2)",
        borderBottom: "1px solid var(--j-line)",
        whiteSpace: "nowrap"
    },
    "& td": {
        height: "var(--j-row)",
        borderBottom: "1px solid var(--j-line-soft)"
    },
    "& tr:last-child td": {
        borderBottom: 0
    },
    "& [data-streamdown] button": {
        display: "inline-grid",
        placeItems: "center",
        minWidth: 24,
        height: 24,
        padding: "0 var(--j-sp-1)",
        border: 0,
        borderRadius: "var(--j-r-sm)",
        background: "transparent",
        color: "var(--j-ink-3)",
        cursor: "pointer",
        "&:hover": {
            background: "var(--j-hover)",
            color: "var(--j-ink)"
        },
        "& svg": {
            width: 14,
            height: 14
        }
    }
});
export function Markdown({ children, className }) {
    return /*#__PURE__*/ React.createElement(Body, {
        className: className
    }, /*#__PURE__*/ React.createElement(Streamdown, {
        controls: false
    }, children));
}
